export const environment = {
  production: false,
  //apiHost: 'https://ncp-dev.azurewebsites.net/api/'
  //apiHost: 'https://ncp-test.azurewebsites.net/api/'
  //apiHost: 'https://ncp.ews-group.dev/api/ncp/',
  apiHost: 'https://ews.netcomm.dev/api/ncp/',
  //apiHost: 'https://ncp-fe.azurewebsites.net/api/'
  //apiHost: 'https://ncp.ews-group.app/api/ncp/'
  //apiHost: '/api/ncp/',
  // remember to change Elastic setting (environment) in app.codule.ts
  version: '2026-01-23',
};
